<template>
  <div>
    <v-card max-width="80%" class="mt-12 mx-auto">
      <v-card-title class="ml-2 title-center" style="color: #3f51b5;">Change Password</v-card-title>
      <div class="ml-8 mr-8 ma-8">
        <v-text-field
          v-model="form.currentpassword"
          :append-icon="show1 ? 'visibility' : 'visibility_off'"
          :type="show1 ? 'text' : 'password'"
          name="input-10-1"
          prepend-inner-icon="lock"
          label="Enter Current Password"
          
          counter
          @click:append="show1 = !show1"
        ></v-text-field>
        <v-text-field
          v-model="form.newpassword"
          prepend-inner-icon="lock"
          :append-icon="show1 ? 'visibility' : 'visibility_off'"
          :type="show2 ? 'text' : 'password'"
          name="input-10-1"
          label="Enter New Password"
          counter
          @click:append="show2 = !show2"
        ></v-text-field>

        <v-text-field
          v-model="form.confirmpassword"
          prepend-inner-icon="lock"
          :append-icon="show3 ? 'visibility' : 'visibility_off'"
          :type="show3 ? 'text' : 'password'"
          name="input-10-1"
          label="Confirm New  Password"
          counter
          @click:append="show3 = !show3"
        ></v-text-field>
        <v-card-actions>
          <v-row justify="center">
            <v-btn outlined rounded @click="changePassword" class="login mb-4" color="primary" dark>
              <v-icon left>mdi-atom-variant</v-icon>change
            </v-btn>
            <router-link to="my-account">
              <v-btn outlined rounded class="login mr-2 ml-2 mb-8" color="primary" dark>
                <v-icon left>mdi-arrow-left-bold-circle-outline</v-icon>Back
              </v-btn>
            </router-link>
          </v-row>
          
        </v-card-actions>
      </div>
    </v-card>
  </div>
</template>
<script>
import { changepass } from "../../services/profile";
import { mapState } from 'vuex';
console.log({"state":mapState});
export default {
  components: {},
  data() {
    return {
      show1: false,
      show2: false,
      show3: false,
      form:{
      currentpassword: "",
      newpassword: "",
      confirmpassword: "",
      
      }
      };
  },
  computed: {
    ...mapState('auth', {
      mobileno: state => state.mobile}),
  },
  methods: {
    async changePassword() {
      try {
        console.log({"this":this});
       const { currentpassword, newpassword, confirmpassword } = this.form;
        const { mobileno } = this
        const result = await changepass({
          mobileno:mobileno,
          currentpassword,
          newpassword,
          confirmpassword
        });
        console.log("password changed", result);
        this.$toasted.success("password Changed Successfully", {
          duration: 4000
        });
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>

<style scoped>
.toastbar {
  margin-top: 4rem !important;
}
</style>
